// extracted by mini-css-extract-plugin
export default {"tag":"V9OJA","tagImg":"agCUi","tagTitle":"_2SZA5","trim":"AbJrx","tagContainer":"_3Ni1S","separator":"_36qkW"};